<script lang="ts">

    import ExperienceProgress from "./ExperienceProgress.svelte";

    export let experiences
    export let roleSearchTerm
    
    const experienceProgress = (max : string) => {
        let percentage : string = '6%'

        if(max === '2') {
            percentage = '11%'
        } else if(max === '4') {
            percentage = '22%'
        }else if(max === '6') {
            percentage = '33%'
        }else if(max === '10') {
            percentage = '56%'
        }else if(max === '15') {
            percentage = '86%'
        }else if(max === null) {
            percentage = '100%'
        }

        return percentage
    }

</script>

<div class="candidate-experience">
    <h4>Roles and experience</h4>
    {#each experiences as experience}
        <ExperienceProgress 
            title={experience.name}
            duration="{experience.years.min} {experience.years.max ? `- ${experience.years.max}` : ''} yrs"
            percentage={experienceProgress(experience.years.max)}
            highlight={roleSearchTerm === experience.name}
        />
    {/each}
</div>

<style lang="postcss">
    .candidate-experience {
        padding:15px 0 20px;
        margin:0 0 12px;
        height:210px;
        overflow: hidden;

        & :global(.experience-progress):nth-child(n+3) {
            margin:12px 0 0;
        }
    }
</style>